<template>
  <v-card class="elevation-0">
    <v-card-title>
      <div class="headline font-weight-medium">
        Patient Details:
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-layout row wrap>
        <v-flex sm4> Name:&nbsp;&nbsp; {{ patient.Name }} </v-flex>
        <v-flex sm3> Patient Id:&nbsp;&nbsp; {{ patient.PatientId }} </v-flex>
        <v-flex sm2> Age:&nbsp;&nbsp; {{ patient.Age }} </v-flex>
        <v-flex sm2>
          Gender:&nbsp;&nbsp; {{ patient.Gender | genderIntString }}
        </v-flex>
        <!--<v-flex sm2>-->
        <!--Married:&nbsp;&nbsp; {{ patient.Married | marriageConverter }}-->
        <!--</v-flex>-->
        <v-flex sm4> Mobile:&nbsp;&nbsp; {{ patient.Mobile }} </v-flex>
        <v-flex sm4> Email:&nbsp;&nbsp; {{ patient.Email }} </v-flex>
        <v-flex sm4>
          No. of SLITs consumed:&nbsp;&nbsp; {{ patient.SlitConsumed }}
        </v-flex>
        <v-flex sm12> Address:&nbsp;&nbsp; {{ patient.Address }} </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["patient"]
};
</script>

<style scoped></style>
